import React from "react";
import "./work.css";
import { works } from "./data.js";

const Work = () => {
  return (
    <section className="work" id="work">
      <div className="work-container container">
        <div className="work-wrapper">
          <div className="section-title works-title">Latest Work</div>
          <div className="work-content">
            {works.map((work) => (
              <div className="single-work" key={work.id}>
                <div className="single-work-left">
                  <a
                    href={work.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link"
                  >
                    <img
                      src={work.image}
                      alt=""
                      className="single-work-image"
                    />
                  </a>
                </div>

                <div className="single-work-right">
                  <div className="work-title">{work.name}</div>
                  <div className="work-description">
                    <div className="client">
                      <span className="mini-title">Client:</span> {work.client}
                    </div>
                    <div className="roles">
                      <span className="mini-title">Roles:</span> {work.roles}
                    </div>
                  </div>
                  <div className="work-bottom">
                    <div className="work-technologies">
                      {work.technologies.map((tech, index) => (
                        <img
                          src={tech}
                          alt=""
                          className="work-icon"
                          key={index}
                        />
                      ))}
                    </div>
                    {work.status === "completed" ? (
                      <a
                        href={work.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link"
                      >
                        <div className="button">See project</div>
                      </a>
                    ) : work.status === "showcase" ? (
                      <a
                        href={work.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link"
                      >
                        <div className="button">Showcase</div>
                      </a>
                    ) : (
                      <div className="button disabled">Coming soon...</div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Work;
